import { createSlice } from "@reduxjs/toolkit";
import {
  addSaga,
  createAsyncSaga,
  createSagaReducer,
  persist,
  sagaSlice,
} from "./sagaStore";
import catUpService from "../services/fetchCatUpData";

interface CatUpState {
  list: { loading: boolean; error: any; data: any };
  status: string | null;
  barcode: string | null;
  domain: string | null;
  isApproved: boolean | null;
  createdAt: string | null;
  modifiedAt: string | null;
  productName: string | null;
  shopId: string | null;
  isFilterApplied: boolean;
  page: number;
}

const initialState: CatUpState = {
  list: {
    loading: false,
    error: null,
    data: {},
  },
  status: null,
  barcode: null,
  domain: null,
  isApproved: null,
  createdAt: null,
  modifiedAt: null,
  productName: null,
  shopId: null,
  isFilterApplied: false,
  page: 1,
};

const Slice: sagaSlice = createSlice({
  ...persist("allCatUpManagement", initialState),
  reducers: {
    ...createSagaReducer("fetchAllCatUp", "list"),
    updateStatus(state, action) {
      state.status = action.payload;
    },
    updateBarcode(state, action) {
      state.barcode = action.payload;
    },
    updateDomain(state, action) {
      state.domain = action.payload;
    },
    updateIsApproved(state, action) {
      state.isApproved = action.payload;
    },
    updateCreatedAt(state, action) {
      state.createdAt = action.payload;
    },
    updateModifiedAt(state, action) {
      state.modifiedAt = action.payload;
    },
    updateProductName(state, action) {
      state.productName = action.payload;
    },
    updateShopId(state, action) {
      state.shopId = action.payload;
    },
    updateFilterButton(state, action) {
      state.isFilterApplied = action.payload;
    },
    setPage(state, action) {
      state.page = action.payload;
    },
  },
});

const fetchAllCatUpSaga = createAsyncSaga(
  "fetchAllCatUp",
  Slice,
  catUpService.fetchCatUpData,
  [
    "page",
    "limit",
    "status",
    "barcode",
    "domain",
    "isApproved",
    "createdAt",
    "modifiedAt",
    "productName",
    "shopId",
  ]
);

addSaga(Slice.actions.fetchAllCatUp.type, fetchAllCatUpSaga);

export const {
  fetchAllCatUp,
  updateStatus,
  updateBarcode,
  updateDomain,
  updateCreatedAt,
  updateModifiedAt,
  updateFilterButton,
  updateIsApproved,
  setPage,
  updateProductName,
  updateShopId,
} = Slice.actions;

export default Slice.reducer;
